import React, { useContext, useState } from 'react';
import { Button, StyleSheet, View } from 'react-native';
import Animated, {
	Easing,
	useAnimatedStyle,
	useSharedValue,
	withTiming,
} from 'react-native-reanimated';
import Trains from '../components/organisms/Trains';
import { vw } from '../constants/size';
import SoundsContext from '../contexts/SoundsContext';

const styles = StyleSheet.create({
	container: {
		flex: 1,
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
	},
	header: {
		position: 'absolute',
		top: 0,
		width: vw,
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	main: {
		flex: 1,
		justifyContent: 'center',
		alignItems: 'center',
	},
	footer: {
		position: 'absolute',
		bottom: 0,
		width: vw,
	},
});

const OFFSETS = [4, 0, -4, 0];

// https://docs.swmansion.com/react-native-reanimated/docs/2.0.0-alpha.8/animations
const HomeScreen: React.VFC = () => {
	const sounds = useContext(SoundsContext);

	const offset = useSharedValue(OFFSETS[0]);
	const [phaseIndex, setPhaseIndex] = useState(0);

	const animatedStyles = useAnimatedStyle(() => {
		return {
			transform: [
				{
					translateX: withTiming(offset.value * 255, {
						duration: 5000,
						easing: Easing.out(Easing.exp),
					}),
				},
			],
		};
	});

	const handlePress = () => {
		const nextPhaseIndex = (phaseIndex + 1) % OFFSETS.length;
		if (OFFSETS[nextPhaseIndex] < 0) {
			sounds?.play('run1');
		} else if (OFFSETS[nextPhaseIndex] === 0) {
			sounds?.play('stopping');
		} else if (OFFSETS[nextPhaseIndex] > 0) {
			sounds?.play('run2');
		}
		offset.value = OFFSETS[nextPhaseIndex];
		setPhaseIndex(nextPhaseIndex);
	};

	return (
		<View style={styles.container}>
			<View style={styles.header}></View>
			<Animated.View style={[styles.main, animatedStyles]}>
				<Trains />
			</Animated.View>
			<View style={styles.footer}>
				<Button title="Go!!" onPress={handlePress} />
			</View>
		</View>
	);
};

export default HomeScreen;
